import { Banner, FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { CommonStrings } from '@b-stock/fe-core/locale'
import type { OfferingDto } from '@b-stock/offering-api-client'

const ns = 'Offerings.Details.offeringStatusBanner.offerNotAccepted'
import useAccount from '@/buyer-portal/helpers/useAccount'

export const OfferNotAcceptedBanner = ({
  offering,
}: {
  offering: OfferingDto
}) => {
  const { data: account } = useAccount(offering.accountId)

  const sellerName = account?.business?.displayName || (
    <CommonStrings.NotAvailableAbbr.Component />
  )

  return (
    <Banner title={<FormattedMessage id={`${ns}.title`} />}>
      <div>
        <FormattedMessage
          id={`${ns}.message`}
          values={{
            sellerName,
          }}
        />
      </div>
    </Banner>
  )
}
